<div class="w-full flex flex-col gap-16 md:gap-28">
  <!-- Sección de la cabecera. -->
  <section class="mt-16 md:mt-28 flex flex-col gap-4">
    <h1 class="text-4xl font-medium md:text-5xl">Productos</h1>
    <p class="text-lg md:text-xl">
      Consulta, añade, edita y elimina los productos.
    </p>
  </section>

  <!-- Sección del cuerpo. -->
  <section class="flex flex-col gap-10">
    <div class="flex flex-col md:flex-row gap-5">
      <button
        mat-raised-button
        aria-hidden="false"
        aria-label="Actualizar"
        (click)="reload()"
        [disabled]="loading"
      >
        <mat-icon>refresh</mat-icon>
        <span>Actualizar</span>
      </button>
      <button
        mat-flat-button
        aria-hidden="false"
        aria-label="Crear"
        (click)="create()"
      >
        <mat-icon>add</mat-icon>
        <span>Crear</span>
      </button>
    </div>

    <div class="overflow-x-auto">
      <table
        mat-table
        [dataSource]="tableData"
        matSort
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por nombre"
          >
            Nombre
          </th>
          <td mat-cell *matCellDef="let product">
            {{ product.name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por descripción"
          >
            Descripción
          </th>
          <td mat-cell *matCellDef="let product">
            {{ product.description }}
          </td>
        </ng-container>
        <ng-container matColumnDef="image">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por imagen"
          >
            Imagen
          </th>
          <td mat-cell *matCellDef="let product">
            @if (product.image) {
            <img [src]="product.image" [alt]="product.name" class="w-[30px]" />
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="disabled">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por estado"
          >
            Activo
          </th>
          <td mat-cell *matCellDef="let product">
            <mat-slide-toggle
              [checked]="!product.disabled"
              (change)="toggleStatus(product, $event.checked)"
            >
            </mat-slide-toggle>
          </td>
        </ng-container>
        <ng-container matColumnDef="updatedAt">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por fecha de modificación"
          >
            Modificado
          </th>
          <td mat-cell *matCellDef="let product" class="text-nowrap">
            {{ product.updatedAt | date : "d MMM, y, H:mm" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="createdAt">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por fecha de creación"
          >
            Creado
          </th>
          <td mat-cell *matCellDef="let product" class="text-nowrap">
            {{ product.createdAt | date : "d MMM, y, H:mm" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let product">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              aria-label="Acciones"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="update(product)">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="delete(product)">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td colspan="9" class="mat-cell py-5 text-gray-500 text-center">
            No hay productos
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20, 50]"
      showFirstLastButtons
      aria-label="Selecciona la página"
    >
    </mat-paginator>
  </section>
</div>
